/** McAuth — 契约 docs/platform/merchant-console/商家控制台RBAC契约.md */
const KEY = "fit1_mc_me";
let cache = null;

function loadCache() {
  if (cache) return cache;
  try {
    cache = JSON.parse(sessionStorage.getItem(KEY) || "null");
  } catch {
    cache = null;
  }
  return cache;
}

function setMe(me) {
  cache = me || null;
  try {
    if (me) sessionStorage.setItem(KEY, JSON.stringify(me));
    else sessionStorage.removeItem(KEY);
  } catch (e) {
    console.warn("McAuth sessionStorage", e);
  }
}

function clear() {
  setMe(null);
}

function roles() {
  const me = loadCache();
  return (me && me.roles) || [];
}

function roleCodes() {
  return roles().map((r) => (r && (r.code || r)) || "").filter(Boolean);
}

function roleDisplayNames() {
  return roles()
    .map((r) => {
      if (!r) return "";
      if (typeof r === "string") return r;
      return (r.name || r.code || "").trim();
    })
    .filter(Boolean);
}

function isOwner() {
  return roleCodes().includes("MERCHANT_OWNER");
}

function isPlatformSuperAdmin() {
  const me = loadCache();
  if (me && me.is_platform_super_admin) return true;
  return roleCodes().includes("PLATFORM_SUPER_ADMIN");
}

function permissions() {
  const me = loadCache();
  const raw = (me && me.permissions) || [];
  if (!Array.isArray(raw)) return [];
  return raw
    .map((p) => {
      if (p == null) return "";
      if (typeof p === "string") return p;
      if (typeof p === "object" && p.code) return String(p.code);
      return String(p);
    })
    .filter(Boolean);
}

/** 是否**已拿到** `/merchant/me`（区别「未知」与「确知无权」的唯一判据）。 */
function isLoaded() {
  return loadCache() !== null;
}

/** 仅平台超级管理员持有 *；* 放行全部权限（含平台专属）
 *
 * ⚠️ **放行只给「还不知道」的人，不给「确知没权限」的人**（2026-10-14 修）：
 * - `isLoaded() === false`（还没拿到 `/merchant/me`：首屏竞态 / 未登录）⇒ 放行，
 *   免得菜单先闪空再长出来；
 * - 已加载 ⇒ 一律按权限码判。
 *
 * 旧写法 `!perms.length && roles().length === 0` 把这两种情况混为一谈，
 * 于是「扫码入店、尚未分配角色」的员工（BS-05 裁定②「没有默认角色」）被当成
 * 放行 —— 侧栏整组「超级管理员」亮起、按钮全出。契约 §0「侧栏「超级管理员」组
 * **无 `*` 则整组隐藏**」与 §0-115「零角色 ⇒ 空态文案」要求的正是相反行为。
 */
function hasPerm(code) {
  if (!code) return true;
  if (!isLoaded()) return true;
  const codes = Array.isArray(code) ? code : [code];
  const perms = permissions();
  if (perms.includes("*")) return true;
  return codes.some((c) => {
    if (perms.includes(c)) return true;
    if (c.endsWith(":read")) {
      const w = c.replace(/:read$/, ":write");
      if (perms.includes(w)) return true;
    }
    return false;
  });
}

function hasAny(codes) {
  return (codes || []).some((c) => hasPerm(c));
}

const McAuth = {
  setMe,
  clear,
  roles,
  roleCodes,
  roleDisplayNames,
  isOwner,
  isPlatformSuperAdmin,
  permissions,
  hasPerm,
  hasAny,
  isLoaded,
  me: loadCache,
};

window.McAuth = McAuth;
export default McAuth;
